
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import ChapterList from './chapter-list'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "chapterlist"
    }}>{`ChapterList`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Navigation`}</p>
    <hr />
    <h2 {...{
      "id": "chapter-list"
    }}>{`Chapter list`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For providing a list of related items grouped under a section or topic.`}</p>
    <Playground __position={1} __code={'<ChapterList\n  sectionHeadline=\"Section headline\"\n  sectionSubheadline=\"Section subheadline\"\n  chapterList={[\n    { text: \'Chapter list: link with arrow\', href: \'/\', id: \'1\' },\n    { text: \'Chapter list: link with arrow\', href: \'/\', id: \'2\' },\n    { text: \'Chapter list: link with arrow\', href: \'/\', id: \'3\' },\n    { text: \'Chapter list: link with arrow\', href: \'/\', id: \'4\' },\n    { text: \'Chapter list: link with arrow\', href: \'/\', id: \'5\' },\n  ]}\n  selected={2}\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ChapterList
    }} mdxType="Playground">
  <ChapterList sectionHeadline='Section headline' sectionSubheadline='Section subheadline' chapterList={[{
        text: 'Chapter list: link with arrow',
        href: '/',
        id: '1'
      }, {
        text: 'Chapter list: link with arrow',
        href: '/',
        id: '2'
      }, {
        text: 'Chapter list: link with arrow',
        href: '/',
        id: '3'
      }, {
        text: 'Chapter list: link with arrow',
        href: '/',
        id: '4'
      }, {
        text: 'Chapter list: link with arrow',
        href: '/',
        id: '5'
      }]} selected={2} mdxType="ChapterList" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "chapter-list-with-index-url"
    }}>{`Chapter list with index URL`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For providing a list of related items grouped under a section or topic with a link back to the section or topic itself.`}</p>
    <Playground __position={3} __code={'<ChapterList\n  sectionHeadline=\"Section headline\"\n  sectionSubheadline=\"Section subheadline\"\n  indexUrl=\"/\"\n  chapterList={[\n    { text: \'Chapter list: link with arrow\', href: \'/\', id: \'1\' },\n    { text: \'Chapter list: link with arrow\', href: \'/\', id: \'2\' },\n    { text: \'Chapter list: link with arrow\', href: \'/\', id: \'3\' },\n    { text: \'Chapter list: link with arrow\', href: \'/\', id: \'4\' },\n    { text: \'Chapter list: link with arrow\', href: \'/\', id: \'5\' },\n  ]}\n  selected={2}\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ChapterList
    }} mdxType="Playground">
  <ChapterList sectionHeadline='Section headline' sectionSubheadline='Section subheadline' indexUrl='/' chapterList={[{
        text: 'Chapter list: link with arrow',
        href: '/',
        id: '1'
      }, {
        text: 'Chapter list: link with arrow',
        href: '/',
        id: '2'
      }, {
        text: 'Chapter list: link with arrow',
        href: '/',
        id: '3'
      }, {
        text: 'Chapter list: link with arrow',
        href: '/',
        id: '4'
      }, {
        text: 'Chapter list: link with arrow',
        href: '/',
        id: '5'
      }]} selected={2} mdxType="ChapterList" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={ChapterList} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;